<template>
    <path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/>
</template>

<script>
    export default {
        name: 'arrow-down',
    }
</script>



// WEBPACK FOOTER //
// src/components/icon/ArrowDown.vue